import z from "zod";

const passwordSchema = z
    .string()
    .min(8, "Heslo musí obsahovat alespoň 8 znaků") // Minimální délka 8 znaků
    .max(100, "Heslo může obsahovat maximálně 100 znaků") // Maximální délka 100 znaků
    .regex(/[A-Z]/, "Heslo musí obsahovat alespoň jedno velké písmeno") // Minimálně 1 velké písmeno
    .regex(/[a-z]/, "Heslo musí obsahovat alespoň jedno malé písmeno") // Minimálně 1 malé písmeno
    .regex(/\d/, "Heslo musí obsahovat alespoň jednu číslici") // Minimálně 1 číslice
    .regex(/[^A-Za-z0-9]/, "Heslo musí obsahovat alespoň jeden speciální znak") // Minimálně 1 speciální znak
    .refine((password) => !/\s/.test(password), "Heslo nesmí obsahovat mezery"); // Zakázány mezery

export {passwordSchema};
